import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import Code from '@mui/icons-material/Code'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import { Button, CircularProgress, Divider, Menu, MenuItem, styled, TableSortLabel } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import { useTheme } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import { makeStyles } from '@mui/styles'
import { Box } from '@mui/system'
import InputCheckbox from 'component/Input/InputCheckbox'
import { colors } from 'constants/theme'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { numberFormat } from 'utils/app.utils'

/** TRANSLATION*/
import _ from 'lodash'
import PaginationTable from 'new-components/pagination/pagination'
import { Droppable } from 'react-beautiful-dnd'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme: any) => ({
  root: {
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.borderInput
    }
  },
  table: {
    border: '1px solid transparent',
    '& .MuiTableBody-root': {
      '& .MuiTableCell-root': {
        verticalAlign: 'top',
        paddingTop: 16,
        paddingBottom: 8,
        '&.update-by': {
          paddingBottom: 0
        }
      }
    }
  },
  header: {
    borderRight: `1px solid ${colors.themeMainColor} !important`,
    borderLeft: `1px solid ${colors.themeMainColor} !important`,
    color: `${colors.white} `,
    '& $th': {
      backgroundColor: colors.themeMainColor,
      color: `${colors.white} `,
      padding: 15
      // border: `1px solid ${colors.themeMainColor} !important`
    },
    '& .MuiTableCell-root.MuiTableCell-head': {
      color: `${colors.white} `,
      fontSize: 16,
      fontWeight: 500,
      border: 'none',
      '&.border-left ': {
        borderLeft: `1px solid ${colors.white} !important`,
      },
      '&.border-right ': {
        borderRight: `1px solid ${colors.white} !important`,
      },
      '&.MuiTableCell-alignRight': {
        flexDirection: 'row'
      }
    },
    '& .MuiTableSortLabel-root': {
      color: `${colors.white}`
    },
    '& .MuiTableSortLabel-root:hover, & .MuiTableSortLabel-active': {
      color: `${colors.white}`,
      fontWeight: 600
    },
    // '& .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
    //   color: `${colors.white} !important`
    // }
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: `${colors.white}`
    },
    // '& .MuiTableSortLabel-root': {
    //   color: `${colors.white} !important`
    // },
    // '& .MuiTableSortLabel-root:hover, & .MuiTableSortLabel-active': {
    //   color: `${colors.white} !important`,
    //   fontWeight: 600
    // },
    // '& .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
    //   color: `${colors.white} !important`
    // }
  },
  body: {
    '&.sm-data-table': {
      borderRight: `1px solid ${colors.lightGray} !important`,
      borderLeft: `1px solid ${colors.lightGray} !important`,
      height: 'auto'
    },
    '& .MuiTableCell-root': {
      borderBottomColor: `${colors.lightGray} !important`,
      fontSize: 16
    },
    '& .MuiTableRow-root:hover .MuiTableCell-root, .MuiTableRow-root-active .MuiTableCell-root': {
      background: colors.extraLightGray
    }
  },
  pagination: {
    border: 'none !important',
    paddingRight: '0 !important',
    '& p': {
      margin: 0,
      color: colors.textLightGray
    },
    '& .MuiTablePagination-select': {
      fontSize: '14px',
      color: colors.textPrimary
    }
  },
  dropdown: {
    '& .MuiCheckbox-root': {
      margin: '-9px 0'
    }
  },
  dropdownToggle: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: `${colors.white} !important`,
    boxShadow: 'none !important',
    '&:focus, &:hover, &:active': {
      boxShadow: 'none !important'
    },
    [theme.breakpoints.up('xs')]: {
      right: '-1.5rem !important'
    }
  },
  dropdownToggleShow: {
    backgroundColor: `${colors.white} !important`,
    zIndex: 5,
    '&:hover': {
      backgroundColor: `${colors.white} !important`
    },
    [theme.breakpoints.up('lg')]: {
      left: '-35px !important'
    }
  },
  iconButton: {
    border: `1px solid ${colors.themeSecondColor} !important`,
    color: `${colors.themeSecondColor}  !important`,
    margin: '2.5px !important',
    '&.MuiButtonBase-root:not(.Mui-disabled)': {
      opacity: 1
    },
    borderRadius: '4px !important',
    width: 29.7,
    height: 29.7,
    fontSize: '16px !important',
    '&:not(.Mui-disabled) $svg': {},
    '&.Mui-disabled': {
      opacity: 0.7
    },
    '&.MuiButtonBase-root.active': {
      backgroundColor: `${colors.themeSecondColor}  !important`,
      color: `${colors.white}  !important`
    },
    '&.MuiButtonBase-root:hover': {
      backgroundColor: `${colors.themeSecondColor}  !important`,
      color: `${colors.white}  !important`
    },
    '&.MuiButtonBase-root.active $svg': {
      color: `${colors.white}  !important`,
      width: 29.7,
      height: 29.7
    }
  }
}))

// const useStyles = makeStyles<Theme>((theme: Theme) => ({
//   root: {
//     '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
//       borderColor: colors.borderInput
//     }
//   },
//   table: {
//     border: '1px solid transparent',
//     '& .MuiTableBody-root': {
//       '& .MuiTableCell-root': {
//         verticalAlign: 'top',
//         paddingTop: 16,
//         paddingBottom: 8,
//         '&.update-by': {
//           paddingBottom: 0
//         }
//       }
//     }
//   },
//   header: {
//     borderRight: `1px solid ${colors.themeMainColor} !important`,
//     borderLeft: `1px solid ${colors.themeMainColor} !important`,
//     color: `${colors.white} `,
//     '& $th': {
//       backgroundColor: colors.themeMainColor,
//       color: `${colors.white} `,
//       padding: 15
//       // border: `1px solid ${colors.themeMainColor} !important`
//     },
//     '& .MuiTableCell-root.MuiTableCell-head': {
//       color: `${colors.white} `,
//       fontSize: 16,
//       fontWeight: 500,
//       border: 'none',
//       '&.border-left ': {
//         borderLeft: `1px solid ${colors.white} !important`,
//       },
//       '&.border-right ': {
//         borderRight: `1px solid ${colors.white} !important`,
//       },
//       '&.MuiTableCell-alignRight': {
//         flexDirection: 'row'
//       }
//     },
//     '& .MuiTableSortLabel-root': {
//       color: `${colors.white}`
//     },
//     '& .MuiTableSortLabel-root:hover, & .MuiTableSortLabel-active': {
//       color: `${colors.white}`,
//       fontWeight: 600
//     },
//     // '& .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
//     //   color: `${colors.white} !important`
//     // }
//     '& .MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
//       color: `${colors.white}`
//     },
//   },
//   body: {
//     '&.sm-data-table': {
//       borderRight: `1px solid ${colors.lightGray} !important`,
//       borderLeft: `1px solid ${colors.lightGray} !important`,
//       height: 'auto'
//     },
//     '& .MuiTableCell-root': {
//       borderBottomColor: `${colors.lightGray} !important`,
//       fontSize: 16
//     },
//     '& .MuiTableRow-root:hover .MuiTableCell-root, .MuiTableRow-root-active .MuiTableCell-root': {
//       background: colors.extraLightGray
//     }
//   },
//   pagination: {
//     border: 'none !important',
//     paddingRight: '0 !important',
//     '& p': {
//       margin: 0,
//       color: colors.textLightGray
//     },
//     '& .MuiTablePagination-select': {
//       fontSize: '14px',
//       color: colors.textPrimary
//     }
//   },
//   dropdown: {
//     '& .MuiCheckbox-root': {
//       margin: '-9px 0'
//     }
//   },
//   dropdownToggle: {
//     position: 'absolute',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     color: `${colors.white}`,
//     boxShadow: 'none !important',
//     '&:focus, &:hover, &:active': {
//       boxShadow: 'none !important'
//     },
//     [theme.breakpoints.up('xs')]: {
//       right: '-1.5rem !important'
//     }
//   },
//   dropdownToggleShow: {
//     backgroundColor: `${colors.white} !important`,
//     zIndex: 5,
//     '&:hover': {
//       backgroundColor: `${colors.white} !important`
//     },
//     [theme.breakpoints.up('lg')]: {
//       left: '-35px !important'
//     }
//   },
//   iconButton: {
//     border: `1px solid ${colors.themeSecondColor} !important`,
//     color: `${colors.themeSecondColor}  !important`,
//     margin: '2.5px !important',
//     '&.MuiButtonBase-root:not(.Mui-disabled)': {
//       opacity: 1
//     },
//     borderRadius: '4px !important',
//     width: 29.7,
//     height: 29.7,
//     fontSize: '16px !important',
//     '&:not(.Mui-disabled) $svg': {},
//     '&.Mui-disabled': {
//       opacity: 0.7
//     },
//     '&.MuiButtonBase-root.active': {
//       backgroundColor: `${colors.themeSecondColor}  !important`,
//       color: `${colors.white}  !important`
//     },
//     '&.MuiButtonBase-root:hover': {
//       backgroundColor: `${colors.themeSecondColor}  !important`,
//       color: `${colors.white}  !important`
//     },
//     '&.MuiButtonBase-root.active $svg': {
//       color: `${colors.white}  !important`,
//       width: 29.7,
//       height: 29.7
//     }
//   }
// }))

export function TablePaginationActions(props: any) {
  const { t } = useTranslation()
  const theme = useTheme()
  const classes = useStyles()

  const { count, page, rowsPerPage, onPageChange } = props

  const handleFirstPageButtonClick = (event: any) => {
    onPageChange(event, 1)
  }

  const handleBackButtonClick = (event: any) => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = (event: any) => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = (event: any) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage)))
  }

  const handleGoPageButtonClick = (event: any, pageClick: number) => {
    onPageChange(event, pageClick)
  }

  const renderPage = (countPage: number) => {
    const htmlPageNo: any = []
    let arrayPage: number[] = [1, 2, 3, countPage]
    if (page > 3) {
      if (page !== countPage) arrayPage = [page - 1, page, page + 1, countPage]
      else if (page === countPage) arrayPage = [page - 2, page - 1, page, countPage]
    }

    for (let index = 0; index < countPage; index++) {
      const pageRun: number = index + 1
      if (arrayPage.includes(pageRun))
        htmlPageNo.push(
          <IconButton className={`${classes.iconButton} ${index + 1 === page ? 'active' : ''}`} onClick={(e) => handleGoPageButtonClick(e, index + 1)} aria-label={String(index + 1)}>
            <div>{index + 1}</div>
          </IconButton>
        )
      else if ((pageRun === 2 && !arrayPage.includes(pageRun)) || (pageRun === countPage - 1 && !arrayPage.includes(pageRun)))
        htmlPageNo.push(
          <IconButton className={`${classes.iconButton} ${index + 1 === page ? 'active' : ''}`} aria-label={String(index + 1)}>
            <div>...</div>
          </IconButton>
        )
    }
    return htmlPageNo
  }

  return (
    <Box className="flex-end" sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton className={classes.iconButton} onClick={handleFirstPageButtonClick} disabled={page === 1} aria-label={t('TABLE.ICON.INDEX')}>
        {theme.direction === 'rtl' ? <LastPageIcon fontSize="small" /> : <FirstPageIcon fontSize="small" />}
      </IconButton>
      <IconButton className={classes.iconButton} onClick={handleBackButtonClick} disabled={page === 1} aria-label={t('TABLE.ICON.PREVIOUS')}>
        {theme.direction === 'rtl' ? <KeyboardArrowRight fontSize="small" /> : <KeyboardArrowLeft fontSize="small" />}
      </IconButton>

      {renderPage(Math.ceil(count / rowsPerPage))}
      <IconButton className={classes.iconButton} onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage)} aria-label={t('TABLE.ICON.NEXT')}>
        {theme.direction === 'rtl' ? <KeyboardArrowLeft fontSize="small" /> : <KeyboardArrowRight fontSize="small" />}
      </IconButton>
      <IconButton className={classes.iconButton} onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage)} aria-label={t('TABLE.ICON.FINAL')}>
        {theme.direction === 'rtl' ? <FirstPageIcon fontSize="small" /> : <LastPageIcon fontSize="small" />}
      </IconButton>
    </Box>
  )
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
}

type HeadCheckboxDropdownProps = {
  headCell: any
  disabled?: boolean
  onDelete?: () => void
  dropdownClass?: string
  toggleClass?: string
  menuClass?: string
}

function HeadCheckboxDropdown({ headCell, disabled, onDelete, dropdownClass, toggleClass, menuClass }: HeadCheckboxDropdownProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClose = () => setAnchorEl(null)
  const handleAction = (cb?: (...args: any[]) => void) => () => {
    if (cb) cb()
    handleClose()
  }
  return (
    <Box className={dropdownClass} sx={{ position: 'relative', display: 'inline-block' }}>
      <InputCheckbox disabled={disabled} onChange={headCell.onCheckAll} value="checkAll" indeterminate={headCell.indeterminate} checked={headCell.checked} />
      <Button
        variant="text"
        disableRipple
        disableElevation
        disabled={headCell.disableDropdown}
        aria-expanded={open}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className={toggleClass}
        sx={{ minWidth: 'unset', padding: 0, '&:hover': { backgroundColor: 'transparent' } }}
      >
        {!_.isEmpty(headCell.values) && <FontAwesomeIcon icon={faCaretDown} />}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ className: menuClass }}
        sx={{ zIndex: 1301 }}
      >
        {headCell.values.map((objVal: any, i: number) => {
          if (objVal.option === 'STATUS_ACTIVE')
            return <MenuItem key={i} onClick={handleAction(headCell.onActive)}>{objVal.label}</MenuItem>
          if (objVal.option === 'STATUS_INACTIVE')
            return <MenuItem key={i} onClick={handleAction(headCell.onInactive)}>{objVal.label}</MenuItem>
          if (objVal.option === 'DIVIDER')
            return <Divider key={i} />
          if (objVal.option === 'COMPONANT')
            return <Box key={i}>{objVal.label}</Box>
          if (objVal.option === 'DELETE')
            return (
              <MenuItem key={i} onClick={handleAction(onDelete)}>
                <FontAwesomeIcon icon={faTrashAlt} />
                <span className="ml-2">{objVal.label}</span>
              </MenuItem>
            )
          return null
        })}
      </Menu>
    </Box>
  )
}

export default function TableCustom(props: any) {
  const { t } = useTranslation()
  const classes = useStyles()
  const rowCount = props.rowCount || 0
  const page = props.page || 1
  const pageLimit = props.pageLimit
  const sortBy = props.sortBy
  const sortType = props.sortType
  const rowsPerPageOptions = [5, 10, 25, 100]

  const headCells = props.headCells
  const rowsData = props.rowsData
  const noHeader = props.noHeader
  const tooltip = props.tooltip
  const newArray = Array.from({ length: props.rowHeadCell || 1 }, (value, index) => index)
  const isLoading = props.isLoading
  const isError = props.isError
  const showEmptyRow = !rowsData.length && !isLoading
  const emptyStateText = isError
    ? (props.textErrorData || t('LOAD_ERROR'))
    : (props.textEmptyData || t('NOT_FOUND'))
  const loadingStateText = props.textLoadingData || t('LOADING')


  const handleRequestSort = (event: any, property: any) => {
    const isAsc = sortBy === property && sortType === 'ASC'
    props.onSort(property, isAsc ? 'DESC' : 'ASC')
  }

  const createSortHandler = (property: any) => (event: any) => {
    handleRequestSort(event, property)
  }
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    props.setPageLimit(parseInt(event.target.value, 10))
    props.setPage(1)
  }

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    props.setPage(newPage)
  }


  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: props.maxHeight,
          overflowY: props.overflowY,
          ...(props.stickyLastColumn ? { overflowX: 'auto' } : {}),
        }}
        className={`${props.customScroll ? 'custom-scroll' : ''} ${props.stickyLastColumn ? 'sticky-last-column-container' : ''}`}
        style={{ boxShadow: 'none', minHeight: 'calc(100% - 65px)', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', overflow: props.overflow || '' }}
      >
        <Table
          stickyHeader
          size="small"
          className={`${classes.table}`}
          sx={{
            minWidth: props.tableMinWidth !== undefined ? props.tableMinWidth : 650,
            tableLayout: props.tableFixedWidth ? 'fixed' : 'auto',
            ...(props.stickyLastColumn ? {
              '& .sticky-last-column': {
                position: 'sticky',
                right: 0,
                zIndex: 3,
                width: 72,
                minWidth: 72,
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
                borderLeft: `1px solid ${colors.lightGray}`,
                boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.04)',
              },
              '& .MuiTableHead-root .sticky-last-column': {
                zIndex: 6,
                backgroundColor: colors.themeMainColor,
                color: colors.white,
                borderLeft: `1px solid ${colors.white} !important`,
              },
              '& .MuiTableBody-root > .MuiTableRow-root > .MuiTableCell-root:last-child:not([colspan])': {
                position: 'sticky',
                right: 0,
                zIndex: 3,
                width: 72,
                minWidth: 72,
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
                borderLeft: `1px solid ${colors.lightGray}`,
                boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.04)',
              },
              '& .MuiTableBody-root > .MuiTableRow-root:hover > .MuiTableCell-root:last-child:not([colspan])': {
                backgroundColor: colors.extraLightGray,
              },
            } : {}),
          }}
        >
          <TableHead className={classes.header}>
            {newArray.map((number: number) => {
              return (
                <TableRow key={number}>
                  {props.headCells.map((headCell: any, index: number) =>
                    headCell.label === 'CHECKBOX' ? (
                      number + 1 === (headCell.row || 1) ? (
                        <TableCell colSpan={headCell.colSpan || 1} rowSpan={headCell.rowSpan || 1} key={headCell.id + number} align="center" padding={'none'} className={props.stickyLastColumn && index === props.headCells.length - 1 ? 'sticky-last-column' : ''} sx={{ width: headCell.width ? headCell.width : 'auto' }}>
                          <HeadCheckboxDropdown
                            headCell={headCell}
                            disabled={props.disabled}
                            onDelete={props.onDelete}
                            dropdownClass={classes.dropdown}
                            toggleClass={`${classes.dropdownToggle}`}
                            menuClass={classes.dropdownToggleShow}
                          />
                        </TableCell>
                      ) : (
                        <></>
                      )
                    ) : number + 1 === (headCell.row || 1) ? (
                      <TableCell
                        colSpan={headCell.colSpan || 1}
                        rowSpan={headCell.rowSpan || 1}
                        key={number}
                        align={headCell.align || ((headCell.id === 'updatedBy' || headCell.id === 'action' || headCell.id === 'status' || headCell.id === 'no' || false) && 'center') || (headCell.id === 'price' && 'right') || 'left'}
                        padding={'none'}
                        sortDirection={sortBy === headCell.id ? sortType.toLowerCase() : false}
                        className={`${headCell?.class || ''} ${props.stickyLastColumn && index === props.headCells.length - 1 ? 'sticky-last-column' : ''}`}
                        sx={{ width: headCell.width ? headCell.width : 'auto' }}
                      >
                        {(headCell.sortable && (
                          <TableSortLabel active={sortBy === headCell.id} direction={sortBy === headCell.id ? sortType.toLowerCase() : 'asc'} onClick={createSortHandler(headCell.id)} hideSortIcon sx={{
                            '& .MuiTableSortLabel-icon path': {
                              fill: 'white',
                            }
                          }}>
                            {headCell.label || t(headCell.labelKey)}
                            {sortBy !== headCell.id && <Code className={'m-1'} sx={{ fontSize: '16px !important', transform: 'rotate(90deg)' }} />}
                          </TableSortLabel>
                        )) ||
                          headCell.label ||
                          t(headCell.labelKey)}
                      </TableCell>
                    ) : (
                      <></>
                    )
                  )}
                </TableRow>
              )
            })}
          </TableHead>
          {!props?.isDrag ?
            <TableBody className={`sm-data-table ${classes.body}`}>
              {isLoading ? (
                <TableRow>
                  <TableCell sx={{ textAlign: 'center !important', padding: '40px 16px !important', color: colors.disabledGray }} colSpan={props.headCells.length}>
                    <Box display="flex" alignItems="center" justifyContent="center" gap="12px">
                      <CircularProgress size={20} />
                      <span>{loadingStateText}</span>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : rowsData}
              {showEmptyRow && (
                <TableRow>
                  <TableCell sx={{ textAlign: 'center !important', padding: '40px 16px !important', color: colors.disabledGray }} colSpan={props.headCells.length}>
                    {emptyStateText}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            :
            <Droppable droppableId={props?.droppableId || "droppable-1"}>
              {(provider) => (
                <TableBody className={`sm-data-table ${classes.body}`}  {...provider.droppableProps} ref={provider.innerRef}>
                  {isLoading ? (
                    <TableRow>
                      <TableCell sx={{ textAlign: 'center !important', padding: '40px 16px !important', color: colors.disabledGray }} colSpan={props.headCells.length}>
                        <Box display="flex" alignItems="center" justifyContent="center" gap="12px">
                          <CircularProgress size={20} />
                          <span>{loadingStateText}</span>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : rowsData}
                  {showEmptyRow && (
                    <TableRow>
                      <TableCell sx={{ textAlign: 'center !important', padding: '40px 16px !important', color: colors.disabledGray }} colSpan={props.headCells.length}>
                        {emptyStateText}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Droppable>
          }
        </Table>
      </TableContainer>
      <Box marginTop="8px">
        {!props.hidePagination &&
          <PaginationTable
            onChange={handleChangePage}
            onPerPageChange={handleChangeRowsPerPage}
            page={page}
            perPage={pageLimit}
            totalPage={rowCount}
          />}
      </Box>
    </>
  )
}
TableCustom.propTypes = {
  page: PropTypes.number.isRequired,
  pageLimit: PropTypes.number.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortType: PropTypes.oneOf(['ASC', 'DESC']).isRequired,
  rowCount: PropTypes.number || 0,
  headCells: PropTypes.array.isRequired,
  rowsData: PropTypes.array.isRequired,
  tooltip: PropTypes.string,
  onSort: PropTypes.func.isRequired,
  setPageLimit: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  customScroll: PropTypes.bool,
  stickyLastColumn: PropTypes.bool,
  verticalAlign: PropTypes.oneOf(['top', 'middle']),
  textEmptyData: PropTypes.string,
  textLoadingData: PropTypes.string,
  textErrorData: PropTypes.string,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  hidePagination: PropTypes.bool,
  tableFixedWidth: PropTypes.bool,
  tableMinWidth: PropTypes.number,
  rowHeadCell: PropTypes.number,
  noHeader: PropTypes.bool,
  disabled: PropTypes.bool,
  isDrag: PropTypes.bool,
  droppableId: PropTypes.string,
  pagination: PropTypes.bool,
  overflow: PropTypes.string,
  maxHeight: PropTypes.number,
  overflowY: PropTypes.string
}

export interface ITablePaginationMiniCustomProps {
  count: number
  page: number
  rowsPerPage: number
  rowCount: number
  pageLimit: number
  headCells: any[]
  onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void
  setPageLimit: (val: any) => void
  setPage: (val: number) => void
}

const TablePaginationMini = styled(TablePagination)(({ theme }) => ({
  '& .MuiTablePagination-selectLabel': { display: 'none' },
  '& .MuiInputBase-root': { display: 'none' },
  [theme.breakpoints.down('sm')]: {
    '& .MuiTablePagination-displayedRows': { display: 'none' }
  }
}))

export function TablePaginationMiniCustom(props: ITablePaginationMiniCustomProps) {
  const { t } = useTranslation()
  const classes = useStyles()
  const rowCount = props.rowCount || 0
  const page = props.page || 1
  const pageLimit = props.pageLimit
  const rowsPerPageOptions = [5, 10, 25, 100]

  const headCells = props.headCells

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    props.setPageLimit(parseInt(event.target.value, 10))
    props.setPage(1)
  }

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    props.setPage(newPage)
  }

  const defaultLabelDisplayedRows = () => {
    const from = page * pageLimit - pageLimit + 1
    const to = page * pageLimit
    const count = Number(rowCount)
    return `${numberFormat(from, 0, 0)} - ${count <= to ? numberFormat(count, 0, 0) : numberFormat(to, 0, 0)} ${t('PAGINATION.LIST')} ${t('PAGINATION.FROM')} ${numberFormat(count, 0, 0)} ${t('PAGINATION.LIST')}`
  }

  const handleRowsPerPageOptions = useCallback(() => {
    if (!rowsPerPageOptions.includes(pageLimit)) {
      const newData = [...rowsPerPageOptions, pageLimit].sort((a: number, b: number) => a - b)
      return newData
    } else {
      return rowsPerPageOptions
    }
  }, [])

  return (
    <div className="row w-100">
      <TablePaginationMini
        className={classes.pagination}
        rowsPerPageOptions={handleRowsPerPageOptions()}
        colSpan={headCells.length}
        count={rowCount || 0}
        rowsPerPage={pageLimit}
        page={page}
        labelRowsPerPage={t('TABLE.PERPAGE')}
        SelectProps={{
          inputProps: {},
          native: true
        }}
        labelDisplayedRows={defaultLabelDisplayedRows}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
    </div>
  )
}
